// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1hIk4","choiceBoxes":"toolbarselects_choiceBoxes__2bPlN","simpleField":"toolbarselects_simpleField__1CW6K"};